import { render, staticRenderFns } from "./AddUserLicense.vue?vue&type=template&id=18b74443&scoped=true&"
import script from "./AddUserLicense.vue?vue&type=script&lang=js&"
export * from "./AddUserLicense.vue?vue&type=script&lang=js&"
import style0 from "./AddUserLicense.vue?vue&type=style&index=0&id=18b74443&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b74443",
  null
  
)

export default component.exports